export const STORAGE_KEYS = {
  AUTH_TOKEN: "auth_token",
  AUTH_REFRESH_TOKEN: "auth_refresh_token",
  AUTH_USER: "auth_user",
  USER_DATA: "user_data",
  THEME: "theme",
  LANGUAGE: "language",
  NOTIFICATIONS: "notifications",
  CURRENT_ORG_UUID: "current_organization_uuid",
  HUB_SELECTED_PROFILE: "hub_selected_profile",
  APP_SETTINGS: "hulahoop_app_settings",
} as const;

export const SESSION_STORAGE_KEYS = {
  AI_AGENT_SESSION_ID: "ai_agent_session_id",
  SKEW_RELOADED_AT: "skew_reloaded_at",
} as const;
